import React, { Component } from "react";
import {
  Grid,
  Row,
  Col
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import InputMask from 'react-input-mask';
import { reservationService } from '../../services/reservation.services';
import { scheduleService } from '../../services/schedule.services';
import { customerService } from '../../services/customer.services';
import SeatMap from '../../components/SeatSelection/SeatMap';
import SeatLegend from '../../components/SeatSelection/SeatLegend';
import { getAvailableSeatIds, getBusLayout, getAllSeatIds, getPricingTiers, getSeatPrice } from '../../components/SeatSelection/seatConfig';
import getSessionId from '../../helpers/sessionId';
import '../../components/SeatSelection/SeatSelection.css';
import { connect } from 'react-redux';
import stopActions from 'actions/stop.actions';
import config from 'config';
import _ from 'lodash';
import moment from 'moment';
import numeral from 'numeral';

function queryStringToJSON(param) {            
  var pairs = param.slice(1).split('&');
  var result = {};
  pairs.forEach(function(pair) {
    pair = pair.split('=');
    result[pair[0]] = decodeURIComponent(pair[1] || '');
  });
  return JSON.parse(JSON.stringify(result));
}

const FUEL_SURCHARGE = 3.00;
const RESERVATION_FEE = 2.25;

class AddMainReservation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      pastDate: false,
      seats: '',
      remark: '',
      paymentMethod: 'card',
      email: '',
      firstName: '',
      lastName: '',
      phone: '',
      zip: '',
      methods: [
        {label: 'Credit Card', value: 'card'},
        {label: 'Ivy Media', value: 'Ivy'},
        {label: 'Points/Coupons', value: 'points'},
        {label: 'No Payment', value: 'none'},
        {label: 'Re-Schedule At The Bus', value: 'reschedule'},
        {label: 'Cust. Already Paid', value: 'alreadyPaid'},
        {label: 'Re-Schedule Old Trip', value: 'rescheduleOld'},
        {label: 'Promotional Code', value: 'promotionalCode'},
      ],
      seatOptions: [],
      cardHolder: '',
      number: '',
      month: '',
      year: '',
      cvv: '',
      months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      years: [],
      price: '',
      result: null,
      credits: 0,
      points: 0,
      useCredits: false,
      usePoints: false,
      totalVouchers: 0,
      totalCredits: 0,
      payment: 0,
      voucherAmount: 0,
      vouchersForFreeTicketDepart: 6,
      vouchersForFreeTicketReturn: 6,
      selectedDepartSeats: [],
      selectedReturnSeats: [],
      pendingDepartSeats: [],
      pendingReturnSeats: [],
      pendingReleaseDepartSeats: [],
      pendingReleaseReturnSeats: [],
      conflictedDepartSeats: [],
      conflictedReturnSeats: [],
      departTakenSeats: [],
      departTempTakenSeats: [],
      departBlockedSeats: [],
      departCapacity: null,
      returnTakenSeats: [],
      returnTempTakenSeats: [],
      returnBlockedSeats: [],
      returnCapacity: null,
      seatInfoLoading: false,
      departPricingTiers: null,
      departApiBasePrice: null,
      returnPricingTiers: null,
      returnApiBasePrice: null,
      departActiveReservations: null,
      returnActiveReservations: null,
    };

    this.handleChange = this.handleChange.bind(this);
    this.getCustomerDetails = this.getCustomerDetails.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDepartSeatSelect = this.handleDepartSeatSelect.bind(this);
    this.handleReturnSeatSelect = this.handleReturnSeatSelect.bind(this);
    this.handleRefreshSeats = this.handleRefreshSeats.bind(this);
    this._handleBeforeUnload = this._handleBeforeUnload.bind(this);
  }

  handleChange(e) {
    const name = e.target.name;

    if(name === 'firstName'){
       this.setState({'cardHolder': e.target.value + ' ' + this.state.lastName})
    }
    else if(name === 'lastName'){
       this.setState({'cardHolder': this.state.firstName + ' ' + e.target.value})
    }

    this.setState({ [e.target.name]: e.target.value }, () => {
      if(name === 'seats' || name === 'price' || name === 'paymentMethod') {
        this.setState({usePoints: false, useCredits: false});
        if (name === 'seats') {
          const count = parseInt(this.state.seats, 10) || 0;
          let departSeats = [];
          let returnSeats = [];
          if (count > 10) {
            const departUnavailable = this.state.departTakenSeats.concat(this.state.departTempTakenSeats).concat(this.state.departBlockedSeats || []);
            departSeats = this.autoSelectSeats(count, this.getDepartBusType(), departUnavailable);
            if (queryStringToJSON(this.props.location.search).return_slot) {
              const returnUnavailable = this.state.returnTakenSeats.concat(this.state.returnTempTakenSeats).concat(this.state.returnBlockedSeats || []);
              returnSeats = this.autoSelectSeats(count, this.getReturnBusType(), returnUnavailable);
            }
          }
          this.setState({
            selectedDepartSeats: departSeats,
            selectedReturnSeats: returnSeats
          }, () => {
            this.getSeatsPrice(parseInt(this.state.seats, 10) || 1, false, false);
          });
        } else {
          this.getSeatsPrice(parseInt(this.state.seats, 10) || 1, false, false);
        }
      }
    });
  }

  handleDepartSeatSelect(seatId) {
    const selectedSeats = this.state.selectedDepartSeats;
    const maxSeats = parseInt(this.state.seats, 10) || 0;

    if ((this.state.pendingDepartSeats && this.state.pendingDepartSeats.length > 0) ||
        (this.state.pendingReleaseDepartSeats && this.state.pendingReleaseDepartSeats.length > 0)) {
      return;
    }

    const search = queryStringToJSON(this.props.location.search);
    const sessionId = getSessionId();

    if (selectedSeats.indexOf(seatId) !== -1) {
      this.setState(function(prev) {
        return {
          selectedDepartSeats: prev.selectedDepartSeats.filter(function(s) { return s !== seatId; }),
          pendingReleaseDepartSeats: prev.pendingReleaseDepartSeats.concat([seatId])
        };
      }, () => {
        this.getSeatsPrice(parseInt(this.state.seats, 10) || 1, false, false);
      });
      scheduleService.releaseSeat(search.schedule_bus, search.date, seatId, sessionId)
        .then(() => {
          this.setState(function(prev) {
            return { pendingReleaseDepartSeats: prev.pendingReleaseDepartSeats.filter(function(s) { return s !== seatId; }) };
          });
          this.silentFetchSeatInfo();
        })
        .catch((err) => {
          console.error('[releaseSeat depart]', err);
          this.setState(function(prev) {
            return { pendingReleaseDepartSeats: prev.pendingReleaseDepartSeats.filter(function(s) { return s !== seatId; }) };
          });
        });
    } else {
      if (selectedSeats.length >= maxSeats) {
        return;
      }
      this.setState(function(prev) {
        return {
          selectedDepartSeats: prev.selectedDepartSeats.concat([seatId]),
          pendingDepartSeats: prev.pendingDepartSeats.concat([seatId])
        };
      }, () => {
        this.getSeatsPrice(parseInt(this.state.seats, 10) || 1, false, false);
      });
      scheduleService.holdSeat(search.schedule_bus, search.date, seatId, sessionId)
        .then(() => {
          this.setState(function(prev) {
            return { pendingDepartSeats: prev.pendingDepartSeats.filter(function(s) { return s !== seatId; }) };
          });
        })
        .catch((err) => {
          if (err && err.status === 409) {
            const freshTempSeats = err.temporaryTakenSeats || null;
            const freshTakenSeats = err.takenSeats || null;
            this.setState(function(prev) {
              var update = {
                pendingDepartSeats: prev.pendingDepartSeats.filter(function(s) { return s !== seatId; }),
                selectedDepartSeats: prev.selectedDepartSeats.filter(function(s) { return s !== seatId; }),
                conflictedDepartSeats: [],
              };
              if (freshTempSeats) {
                update.departTempTakenSeats = freshTempSeats;
              }
              if (freshTakenSeats) {
                update.departTakenSeats = freshTakenSeats;
              }
              if (!freshTempSeats && !freshTakenSeats) {
                update.conflictedDepartSeats = prev.conflictedDepartSeats.indexOf(seatId) === -1
                  ? prev.conflictedDepartSeats.concat([seatId])
                  : prev.conflictedDepartSeats;
              }
              return update;
            }, () => {
              this.getSeatsPrice(parseInt(this.state.seats, 10) || 1, false, false);
            });
            if (!freshTempSeats && !freshTakenSeats) this.silentFetchSeatInfo();
          } else {
            this.setState(function(prev) {
              return { pendingDepartSeats: prev.pendingDepartSeats.filter(function(s) { return s !== seatId; }) };
            });
          }
          console.error('[holdSeat depart]', err);
        });
    }
  }

  handleReturnSeatSelect(seatId) {
    const selectedSeats = this.state.selectedReturnSeats;
    const maxSeats = parseInt(this.state.seats, 10) || 0;

    if ((this.state.pendingReturnSeats && this.state.pendingReturnSeats.length > 0) ||
        (this.state.pendingReleaseReturnSeats && this.state.pendingReleaseReturnSeats.length > 0)) {
      return;
    }

    const search = queryStringToJSON(this.props.location.search);
    const sessionId = getSessionId();

    if (selectedSeats.indexOf(seatId) !== -1) {
      this.setState(function(prev) {
        return {
          selectedReturnSeats: prev.selectedReturnSeats.filter(function(s) { return s !== seatId; }),
          pendingReleaseReturnSeats: prev.pendingReleaseReturnSeats.concat([seatId])
        };
      }, () => {
        this.getSeatsPrice(parseInt(this.state.seats, 10) || 1, false, false);
      });
      scheduleService.releaseSeat(search.return_schedule_bus, search.return_date, seatId, sessionId)
        .then(() => {
          this.setState(function(prev) {
            return { pendingReleaseReturnSeats: prev.pendingReleaseReturnSeats.filter(function(s) { return s !== seatId; }) };
          });
          this.silentFetchSeatInfo();
        })
        .catch((err) => {
          console.error('[releaseSeat return]', err);
          this.setState(function(prev) {
            return { pendingReleaseReturnSeats: prev.pendingReleaseReturnSeats.filter(function(s) { return s !== seatId; }) };
          });
        });
    } else {
      if (selectedSeats.length >= maxSeats) {
        return;
      }
      this.setState(function(prev) {
        return {
          selectedReturnSeats: prev.selectedReturnSeats.concat([seatId]),
          pendingReturnSeats: prev.pendingReturnSeats.concat([seatId])
        };
      }, () => {
        this.getSeatsPrice(parseInt(this.state.seats, 10) || 1, false, false);
      });
      scheduleService.holdSeat(search.return_schedule_bus, search.return_date, seatId, sessionId)
        .then(() => {
          this.setState(function(prev) {
            return { pendingReturnSeats: prev.pendingReturnSeats.filter(function(s) { return s !== seatId; }) };
          });
        })
        .catch((err) => {
          if (err && err.status === 409) {
            const freshTempSeats = err.temporaryTakenSeats || null;
            const freshTakenSeats = err.takenSeats || null;
            this.setState(function(prev) {
              var update = {
                pendingReturnSeats: prev.pendingReturnSeats.filter(function(s) { return s !== seatId; }),
                selectedReturnSeats: prev.selectedReturnSeats.filter(function(s) { return s !== seatId; }),
                conflictedReturnSeats: [],
              };
              if (freshTempSeats) {
                update.returnTempTakenSeats = freshTempSeats;
              }
              if (freshTakenSeats) {
                update.returnTakenSeats = freshTakenSeats;
              }
              if (!freshTempSeats && !freshTakenSeats) {
                update.conflictedReturnSeats = prev.conflictedReturnSeats.indexOf(seatId) === -1
                  ? prev.conflictedReturnSeats.concat([seatId])
                  : prev.conflictedReturnSeats;
              }
              return update;
            }, () => {
              this.getSeatsPrice(parseInt(this.state.seats, 10) || 1, false, false);
            });
            if (!freshTempSeats && !freshTakenSeats) this.silentFetchSeatInfo();
          } else {
            this.setState(function(prev) {
              return { pendingReturnSeats: prev.pendingReturnSeats.filter(function(s) { return s !== seatId; }) };
            });
          }
          console.error('[holdSeat return]', err);
        });
    }
  }

  getDepartBusType() {
    return queryStringToJSON(this.props.location.search).bus_type || 'Standard';
  }

  getReturnBusType() {
    return queryStringToJSON(this.props.location.search).return_bus_type || 'Standard';
  }

  autoSelectSeats(count, busType, takenSeats) {
    const selectableIds = getAvailableSeatIds(busType);
    const selectableAvailable = selectableIds.filter(function(id) { return takenSeats.indexOf(id) === -1; });
    return selectableAvailable.slice(0, count);
  }

  applyCredit() {
    this.setState({useCredits: true, usePoints: false});
    this.getSeatsPrice(this.state.seats, true, false);
  }

  removeCredit() {
    this.setState({useCredits: false});
    this.getSeatsPrice(this.state.seats, false, false);
  }

  applyPoints() {
    this.setState({usePoints: true, useCredits: false});
    this.getSeatsPrice(this.state.seats, false, true);
  }

  removePoints() {
    this.setState({usePoints: false});
    this.getSeatsPrice(this.state.seats, false, false);
  }

  componentDidMount() {
    this.props.dispatch(stopActions.getStops({}));
    let years = [];
    let start = new Date().getFullYear();
    let end = start + 11;
    for (let i = start; i < end; i++) {
      years.push(i.toString().substr(2));
    }
    let seats = [{label: 'Select...', value: ''}];
    for(let i = 1; i <= 40; i++) {
      seats.push({label: i, value: i});
    }
    this.setState({ years: years, seatOptions: seats });
    if(queryStringToJSON(this.props.location.search).bus_type === 'Elite') {
      this.setState({vouchersForFreeTicketDepart: 12});
    }
    if(queryStringToJSON(this.props.location.search).return_bus_type === 'Elite') {
      this.setState({vouchersForFreeTicketReturn: 12});
    }
    if(queryStringToJSON(this.props.location.search).date) {
      let date = queryStringToJSON(this.props.location.search).date;
      let slot = queryStringToJSON(this.props.location.search).slot;
      if(moment(date + ' ' + slot, 'YYYY-MM-DD HH:mm:ss').diff(moment(), 'seconds') < 0) {
        this.setState({pastDate: true});
      }
    }
    this.fetchSeatInfo();
    window.addEventListener('beforeunload', this._handleBeforeUnload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this._handleBeforeUnload);
    const sessionId = getSessionId();
    scheduleService.releaseAllHolds(sessionId)
      .catch(function(err) { console.error('[releaseAllHolds unmount]', err); });
  }

  _handleBeforeUnload() {
    const sessionId = getSessionId();
    const url = `${config.apiUrl}/schedule/seats/hold/session`;
    const xhr = new XMLHttpRequest();
    xhr.open('DELETE', url, false);
    xhr.setRequestHeader('Content-Type', 'application/json');
    try {
      xhr.send(JSON.stringify({ session_id: sessionId }));
    } catch (_e) {
      // Best-effort; holds expire on backend after 2 minutes anyway
    }
  }

  silentFetchSeatInfo() {
    return this._fetchSeatInfoInternal(false);
  }

  fetchSeatInfo() {
    return this._fetchSeatInfoInternal(true);
  }

  _fetchSeatInfoInternal(showLoading) {
    const search = queryStringToJSON(this.props.location.search);
    const sessionId = getSessionId();
    console.log('[SeatInfo] Fetching seat info, session_id:', sessionId, 'schedule_bus:', search.schedule_bus, 'date:', search.date, 'showLoading:', showLoading);
    if (showLoading) this.setState({ seatInfoLoading: true });

    const departPromise = scheduleService.getSeatInfo(search.schedule_bus, search.date, sessionId, search.departCity, search.arriveCity)
      .then((data) => {
        console.log('[SeatInfo] Depart response - temporaryTakenSeats:', data.temporaryTakenSeats, 'takenSeats:', data.takenSeats);
        this.setState({
          departTakenSeats: data.takenSeats || [],
          departTempTakenSeats: data.temporaryTakenSeats || [],
          departBlockedSeats: data.blockedSeats || [],
          departPricingTiers: (data.pricing && data.pricing.tiers) || null,
          departApiBasePrice: (data.pricing && data.pricing.basePrice) || null,
          departActiveReservations: typeof data.activeReservations === 'number' ? data.activeReservations : null,
          departCapacity: typeof data.capacity === 'number' ? data.capacity : null,
          conflictedDepartSeats: [],
        });
      })
      .catch(function(err) { console.error('[getSeatInfo depart]', err); });

    const promises = [departPromise];

    if (search.return_slot && search.return_schedule_bus) {
      const returnPromise = scheduleService.getSeatInfo(search.return_schedule_bus, search.return_date, sessionId, search.returnDepartCity, search.returnArriveCity)
        .then((data) => {
          this.setState({
            returnTakenSeats: data.takenSeats || [],
            returnTempTakenSeats: data.temporaryTakenSeats || [],
            returnBlockedSeats: data.blockedSeats || [],
            returnPricingTiers: (data.pricing && data.pricing.tiers) || null,
            returnApiBasePrice: (data.pricing && data.pricing.basePrice) || null,
            returnActiveReservations: typeof data.activeReservations === 'number' ? data.activeReservations : null,
            returnCapacity: typeof data.capacity === 'number' ? data.capacity : null,
            conflictedReturnSeats: [],
          });
        })
        .catch(function(err) { console.error('[getSeatInfo return]', err); });
      promises.push(returnPromise);
    }

    return Promise.all(promises).then(() => {
      if (showLoading) this.setState({ seatInfoLoading: false });
    });
  }

  handleRefreshSeats() {
    this.fetchSeatInfo().then(() => {
      const allTakenDepart = (this.state.departTakenSeats || []).concat(this.state.departTempTakenSeats || []);
      const allTakenReturn = (this.state.returnTakenSeats || []).concat(this.state.returnTempTakenSeats || []);
      this.setState({
        selectedDepartSeats: this.state.selectedDepartSeats.filter(function(s) { return allTakenDepart.indexOf(s) === -1; }),
        selectedReturnSeats: this.state.selectedReturnSeats.filter(function(s) { return allTakenReturn.indexOf(s) === -1; }),
      });
    });
  }

  getCustomerDetails() {
    this.setState({credits: 0, points: 0, usePoints: 0, useCredits: 0, totalVouchers: 0, totalCredits: 0, payment: 0, voucherAmount: 0});
    if(!this.state.email) {
      return;
    }
    else {
      customerService.getByEmail(this.state.email).then((user) => {
        console.log(user);
        this.setState({
          points: user.points,
          credits: user.credits,
          firstName: user.firstName,
          lastName: user.lastName,
          cardHolder: `${user.firstName} ${user.lastName}`,
          phone: user.phone,
          zip: user.zip
        });
      })
      .catch(err => {
        this.setState({loading: false});
        console.log(err);
      })
    }
  }

  getCityCode(city) {
    const stop = _.find(this.props.stops || [], {city: city});
    return stop ? stop.code : '';
  }

  // A price typed into "Custom Price Per Seat" replaces the BASE fare for every ticket on this
  // booking; seat add-ons are still charged on top. An empty field falls through to the live
  // server price, so ordinary bookings are unaffected.
  getDepartBasePrice() {
    const typed = parseFloat(this.state.price);
    if (!isNaN(typed)) return typed;
    return this.state.departApiBasePrice || parseFloat(queryStringToJSON(this.props.location.search).price);
  }

  getReturnBasePrice() {
    const typed = parseFloat(this.state.price);
    if (!isNaN(typed)) return typed;
    return this.state.returnApiBasePrice || parseFloat(queryStringToJSON(this.props.location.search).return_price);
  }

  getSeatPriceForId(seatId, busType) {
    return getSeatPrice(seatId, this.getDepartBasePrice(), busType, this.state.departPricingTiers);
  }

  getSeatsPrice(seat, useCredits, usePoints) {
    let seats = seat;
    let data = [];
    let obj;
    let vouchers = this.state.points;
    let credits = 0;
    let totalVouchers = 0;
    let creditUsed = 0, paid = 0, payment = 0, voucherAmount = 0;

    const departBusType = this.getDepartBusType();
    const returnBusType = this.getReturnBusType();
    const departSeats = this.state.selectedDepartSeats;
    const returnSeats = this.state.selectedReturnSeats;
    const hasDepartSeatSelection = departSeats.length > 0;

    const departBasePrice = this.getDepartBasePrice();
    let totalPrice = 0;
    for (let i = 0; i < seats; i++) {
      if (hasDepartSeatSelection && i < departSeats.length) {
        totalPrice += this.getSeatPriceForId(departSeats[i], departBusType);
      } else {
        totalPrice += departBasePrice;
      }
    }
    if(queryStringToJSON(this.props.location.search).return_slot) {
      const returnBasePrice = this.getReturnBasePrice();
      for (let i = 0; i < seats; i++) {
        if (returnSeats.length > 0 && i < returnSeats.length) {
          totalPrice += getSeatPrice(returnSeats[i], returnBasePrice, returnBusType, this.state.returnPricingTiers);
        } else {
          totalPrice += returnBasePrice;
        }
      }
    }
    totalPrice = totalPrice + RESERVATION_FEE + FUEL_SURCHARGE;
    if(useCredits && this.state.credits > totalPrice) {
      credits = totalPrice;
    }
    if(useCredits && this.state.credits <= totalPrice) {
      credits = this.state.credits;
    }
    this.setState({totalCredits: credits});

    for (let i = 0; i < seats; i++) {
      creditUsed = 0;
      const seatPrice = (hasDepartSeatSelection && i < departSeats.length)
        ? this.getSeatPriceForId(departSeats[i], departBusType)
        : departBasePrice;
      obj = {
        price: seatPrice,
        paid: 0,
        vouchers: 0,
        credit: 0
      };
      if (hasDepartSeatSelection && i < departSeats.length) {
        obj.seat_number = departSeats[i];
      }
      if(this.state.paymentMethod === 'card' || this.state.paymentMethod === 'Ivy') {
        if(usePoints && vouchers >= this.state.vouchersForFreeTicketDepart) {
          obj.vouchers = this.state.vouchersForFreeTicketDepart;
          vouchers -= this.state.vouchersForFreeTicketDepart;
          // Points cover the base fare only — seat add-ons are always cash (matches the customer site)
          voucherAmount += departBasePrice;
          totalVouchers += this.state.vouchersForFreeTicketDepart;
          obj.paid = Math.max(0, seatPrice - departBasePrice);
        }
        else if(useCredits && credits > 0) {
          creditUsed = (credits > seatPrice) ? seatPrice : credits;
          paid = seatPrice - creditUsed;
          obj.credit = creditUsed;
          obj.paid = paid;
          credits -= creditUsed;
        }
        else {
          obj.paid = seatPrice;
        }
      }
      payment += obj.paid;
      data.push(obj);
    }
    if (queryStringToJSON(this.props.location.search).return_slot) {
      const hasReturnSeatSelection = returnSeats.length > 0;
      const returnBasePriceForItems = this.getReturnBasePrice();
      for (let i = 0; i < seats; i++) {
        const seatPrice = (hasReturnSeatSelection && i < returnSeats.length)
          ? getSeatPrice(returnSeats[i], returnBasePriceForItems, returnBusType, this.state.returnPricingTiers)
          : returnBasePriceForItems;
        obj = {
          return: true,
          price: seatPrice,
          paid: 0,
          vouchers: 0,
          credit: 0
        };
        if (hasReturnSeatSelection && i < returnSeats.length) {
          obj.seat_number = returnSeats[i];
        }
        if(this.state.paymentMethod === 'card' || this.state.paymentMethod === 'Ivy') {
          if(usePoints && vouchers >= this.state.vouchersForFreeTicketReturn) {
            obj.vouchers = this.state.vouchersForFreeTicketReturn;
            vouchers -= this.state.vouchersForFreeTicketReturn;
            totalVouchers += this.state.vouchersForFreeTicketReturn;
            // Points cover the base fare only — seat add-ons are always cash (matches the customer site)
            voucherAmount += returnBasePriceForItems;
            obj.paid = Math.max(0, seatPrice - returnBasePriceForItems);
          }
          else if(useCredits && credits > 0) {
            creditUsed = (credits > seatPrice) ? seatPrice : credits;
            paid = seatPrice - creditUsed;
            obj.credit = creditUsed;
            obj.paid = paid;
            credits -= creditUsed;
          }
          else {
            obj.paid = seatPrice;
          }
        }
        payment += obj.paid;
        data.push(obj);
      }
    }
    if(usePoints || !useCredits || (useCredits && this.state.credits < totalPrice)) {
      payment = payment + RESERVATION_FEE + FUEL_SURCHARGE;
    }
    this.setState({totalVouchers: totalVouchers, payment: payment, voucherAmount: voucherAmount});
    return data;
  }

  checkDisabledPoints() {
    if(this.state.points >= 6 && queryStringToJSON(this.props.location.search).bus_type === 'Standard') {
      return false
    }
    if(this.state.points >= 12 && queryStringToJSON(this.props.location.search).bus_type === 'Elite') {
      return false
    }
    return true
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true, error: '', result: null});
    const effectiveSeats = this.state.seats;
    if (this.state.firstName && this.state.lastName && this.state.email && this.state.phone && effectiveSeats && (this.state.zip || this.state.paymentMethod === 'Ivy') && ((this.state.paymentMethod === 'Ivy' && this.state.price) || this.state.paymentMethod !== 'Ivy')) {
      let data = {
        schedule_bus: queryStringToJSON(this.props.location.search).schedule_bus,
        date: queryStringToJSON(this.props.location.search).date,
        status: 'active',
        slot: queryStringToJSON(this.props.location.search).slot,
        departCity: queryStringToJSON(this.props.location.search).departCity,
        departCityCode: this.getCityCode(queryStringToJSON(this.props.location.search).departCity),
        arriveCity: queryStringToJSON(this.props.location.search).arriveCity,
        seats: parseInt(effectiveSeats, 10),
        email: this.state.email,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        phone: this.state.phone,
        zip: this.state.zip || '',
        paymentMethod: this.state.paymentMethod,
        depart_stop: queryStringToJSON(this.props.location.search).depart_stop,
        arrive_stop: queryStringToJSON(this.props.location.search).arrive_stop,
        remark: this.state.remark,
        depart_price: queryStringToJSON(this.props.location.search).price,
        depart_amount: queryStringToJSON(this.props.location.search).price,
        letter: queryStringToJSON(this.props.location.search).letter,
        remainingSeats: queryStringToJSON(this.props.location.search).remainingSeats
      }
      if(queryStringToJSON(this.props.location.search).return_slot) {
        data.return_slot = queryStringToJSON(this.props.location.search).return_slot;
        data.return_depart_stop = queryStringToJSON(this.props.location.search).return_depart_stop;
        data.return_arrive_stop = queryStringToJSON(this.props.location.search).return_arrive_stop;
        data.returnCityCode = this.getCityCode(queryStringToJSON(this.props.location.search).arriveCity);
        data.return_schedule_bus = queryStringToJSON(this.props.location.search).return_schedule_bus;
        data.return_date = queryStringToJSON(this.props.location.search).return_date;
        data.return_price = queryStringToJSON(this.props.location.search).return_price;
        data.return_amount = queryStringToJSON(this.props.location.search).return_price;
        data.letter1 = queryStringToJSON(this.props.location.search).letter1;
        data.remainingSeatsReturn = queryStringToJSON(this.props.location.search).remainingSeatsReturn;
        data.returnDepartCity = queryStringToJSON(this.props.location.search).returnDepartCity;
        data.returnArriveCity = queryStringToJSON(this.props.location.search).returnArriveCity;
      }
      if(this.state.price) {
        data.depart_price = parseFloat(this.state.price);
        if(queryStringToJSON(this.props.location.search).return_slot) {
          data.return_price = parseFloat(this.state.price);
        }
      }
      data.seats = this.getSeatsPrice(parseInt(effectiveSeats, 10), this.state.useCredits, this.state.usePoints);

      if (this.state.selectedDepartSeats.length > 0) {
        const departBusType = this.getDepartBusType();
        let departTotal = 0;
        for (let i = 0; i < this.state.selectedDepartSeats.length; i++) {
          departTotal += this.getSeatPriceForId(this.state.selectedDepartSeats[i], departBusType);
        }
        data.depart_amount = departTotal / this.state.selectedDepartSeats.length;
      }
      if (queryStringToJSON(this.props.location.search).return_slot && this.state.selectedReturnSeats.length > 0) {
        const returnBusType = this.getReturnBusType();
        const returnBasePrice = this.getReturnBasePrice();
        let returnTotal = 0;
        for (let i = 0; i < this.state.selectedReturnSeats.length; i++) {
          returnTotal += getSeatPrice(this.state.selectedReturnSeats[i], returnBasePrice, returnBusType, this.state.returnPricingTiers);
        }
        data.return_amount = returnTotal / this.state.selectedReturnSeats.length;
      }

      data.credit = this.state.totalCredits;
      data.voucher = this.state.totalVouchers;
      data.voucherAmount = this.state.voucherAmount;
      if(data.credit > 0) {
        data.paymentMethod = 'Tripperbus Credits'
      }
      if(data.voucherAmount > 0) {
        data.paymentMethod = 'Tripperbus Points'
      }
      if((this.state.paymentMethod === 'card' || this.state.paymentMethod === 'Ivy') && !this.state.useCredits && !this.state.usePoints) {
        data.payment = this.getTotal();
      }
      else {
        data.payment = this.state.payment;
      }
      if(this.state.paymentMethod === 'card' && data.payment) {
        if(!this.state.number || !this.state.cvv || !this.state.month || !this.state.year) {
          return;
        }
        data.number = this.state.number.split('-').join('');
        data.cvv = this.state.cvv;
        data.expiryDate = '' + this.state.month + '' + this.state.year;
        data.cardHolder = this.state.cardHolder || (this.state.firstName + ' ' + this.state.lastName);
        data.paymentMethod = 'card';
      }
      data.session_id = getSessionId();
      this.setState({loading: true});
      reservationService.addMainReservation(data)
      .then(result => {
        scheduleService.releaseAllHolds(getSessionId())
          .catch(function(err) { console.error('[releaseAllHolds submit]', err); });
        console.log(result);
        let obj = {
          departTrip: {
            code: result.departTripCode,
            address: queryStringToJSON(this.props.location.search).depart_address,
            time: queryStringToJSON(this.props.location.search).slot,
            date: queryStringToJSON(this.props.location.search).date,
            name: this.state.firstName + ' ' + this.state.lastName,
            seats: this.state.seats,
            email: this.state.email
          }
        }
        if(result.returnTripCode) {
          obj.returnTrip = {
            code: result.returnTripCode,
            address: queryStringToJSON(this.props.location.search).return_address,
            time: queryStringToJSON(this.props.location.search).return_slot,
            date: queryStringToJSON(this.props.location.search).return_date,
            name: this.state.firstName + ' ' + this.state.lastName
          };
        }
        this.setState({
          result: obj,
          loading: false
        });
        this.setState({
          submitted: false,
          seats: '',
          paymentMethod: 'card',
          email: '',
          firstName: '',
          lastName: '',
          phone: '',
          cardHolder: '',
          number: '',
          month: '',
          year: '',
          cvv: '',
          zip: '',
          price: '',
          remark: '',
          selectedDepartSeats: [],
          selectedReturnSeats: [],
        });
        window.scrollTo(0, 0);
      })
      .catch(err => {
        console.log(err);
        this.setState({loading: false, error: err});
      });
    }
  }

  getTotal() {
    const departSeats = this.state.selectedDepartSeats;
    const returnSeats = this.state.selectedReturnSeats;
    const seats = parseInt(this.state.seats, 10) || 0;
    const departBasePrice = this.getDepartBasePrice();

    let total = 0;
    for (let i = 0; i < seats; i++) {
      if (departSeats.length > 0 && i < departSeats.length) {
        total += this.getSeatPriceForId(departSeats[i], this.getDepartBusType());
      } else {
        total += departBasePrice;
      }
    }

    if(queryStringToJSON(this.props.location.search).return_slot) {
      const returnBasePrice = this.getReturnBasePrice();
      for (let i = 0; i < seats; i++) {
        if (returnSeats.length > 0 && i < returnSeats.length) {
          total += getSeatPrice(returnSeats[i], returnBasePrice, this.getReturnBusType(), this.state.returnPricingTiers);
        } else {
          total += returnBasePrice;
        }
      }
    }
    total += RESERVATION_FEE + FUEL_SURCHARGE;
    return total;
  }

  getStopSeats() {
    let search = queryStringToJSON(this.props.location.search);
    if(search.return_slot) {
      return 'Depart Stop Total: '+search.depart_stop_total + ', Depart Bus Total: ' + search.depart_bus_total + '. Return Stop Total: '+search.return_stop_total + ', Return Bus Total: ' + search.return_bus_total;
    }
    return 'Stop Total: '+search.depart_stop_total + ', Bus Total: ' + search.depart_bus_total;
  }

  getDates(){
    let search = queryStringToJSON(this.props.location.search);

    if(search.return_date){
      return `Depart Date: ${search.date} , Return Date ${search.return_date}` 
    }else{
      return `Depart Date: ${search.date}`
    }
  }

  renderSeatSection(title, busType, basePrice, selectedSeats, onSeatSelect, takenSeats, temporaryTakenSeats, busTotal, apiTiers, blockedSeats, apiCapacity, pendingSeats, conflictedSeats, pendingReleaseSeats, showFees) {
    const busLayout = getBusLayout(busType);
    const pricingTiers = apiTiers || getPricingTiers(busType);
    const maxSeats = parseInt(this.state.seats, 10) || 0;
    const isDisabled = !this.state.seats;
    const actualTaken = takenSeats || [];
    const actualTempTaken = (temporaryTakenSeats || []).concat(conflictedSeats || []);
    const allSeatIds = getAllSeatIds(busType);
    const unavailable = actualTaken.concat(actualTempTaken);
    const availableCount = allSeatIds.filter(function(id) { return unavailable.indexOf(id) === -1; }).length;
    const showCapacityWarning = maxSeats > 0 && maxSeats > availableCount;
    const isRefreshing = this.state.seatInfoLoading;

    // Prefer the API-resolved capacity (DB bus_type.capacity, accounting for
    // any override) so this panel matches what the booking math uses.
    // Falls back to the layout total only if the API didn't return one.
    const totalCapacity = (typeof apiCapacity === 'number' && apiCapacity > 0) ? apiCapacity : (busLayout.totalSeats || 0);
    const effectiveBusTotal = busTotal || 0;
    const blockedSet = blockedSeats || [];
    const uniqueTaken = [];
    for (var i = 0; i < actualTaken.length; i++) {
      if (actualTaken[i] && actualTaken[i].trim() && uniqueTaken.indexOf(actualTaken[i]) === -1 && blockedSet.indexOf(actualTaken[i]) === -1) {
        uniqueTaken.push(actualTaken[i]);
      }
    }
    const assignedSeats = uniqueTaken.length;
    const unassignedPassengers = Math.max(0, effectiveBusTotal - assignedSeats);
    // Admin blocks count toward effective occupancy (block = unavailable for booking).
    const blockedCount = (blockedSeats || []).length;
    const remainingCapacity = Math.max(0, totalCapacity - effectiveBusTotal - blockedCount);
    const isBusFull = effectiveBusTotal + blockedCount > 0 && (effectiveBusTotal + blockedCount) >= totalCapacity;

    return (
      <div className={'admin-seat-selection' + (isDisabled ? ' disabled' : '') + (isRefreshing && !isDisabled ? ' refreshing' : '')}>
        <div className="seat-section-header">
          <span className="header-title">{title} ({busType})</span>
          <div className="header-right">
            <span className="selected-count">{selectedSeats.length} / {maxSeats} seat{maxSeats !== 1 ? 's' : ''} selected</span>
            <button
              className={'btn-refresh' + (isRefreshing ? ' refreshing' : '')}
              onClick={this.handleRefreshSeats}
              title="Refresh seat availability"
              disabled={isRefreshing}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
              </svg>
            </button>
          </div>
        </div>
        <div className="seat-section-body">
          {isDisabled && (
            <div className="disabled-overlay">Select number of seats above to begin seat selection</div>
          )}
          {isRefreshing && !isDisabled && (
            <div className="refreshing-overlay">
              <div className="refresh-indicator">
                <svg className="refresh-spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
                </svg>
                <span>Checking availability...</span>
              </div>
            </div>
          )}
          {!isDisabled && isBusFull && (
            <div className="bus-full-notice">
              Bus is full. No seats available for selection. Booking will proceed without seat assignment.
            </div>
          )}
          {!isBusFull && (
            <div className="instruction-text">Click on a seat to select or deselect it</div>
          )}
          <div className="seat-map-container">
            {(
              <div className="bus-status-note">
                <div className="status-title">Bus Status</div>
                <div className="status-row">
                  <span className="status-label">Capacity</span>
                  <span className="status-value">{totalCapacity}</span>
                </div>
                <div className="status-row">
                  <span className="status-label">Booked</span>
                  <span className="status-value">{effectiveBusTotal}</span>
                </div>
                <div className="status-row sub">
                  <span className="status-label">Assigned Seats</span>
                  <span className="status-value">{assignedSeats}</span>
                </div>
                <div className="status-row sub">
                  <span className="status-label">Unassigned Seats</span>
                  <span className="status-value">{unassignedPassengers}</span>
                </div>
                {blockedCount > 0 && (
                  <div className="status-row">
                    <span className="status-label">Blocked</span>
                    <span className="status-value">{blockedCount}</span>
                  </div>
                )}
                <div className="status-divider"></div>
                <div className="status-row">
                  <span className="status-label">Remaining</span>
                  <span className="status-value">{remainingCapacity}</span>
                </div>
              </div>
            )}
            {!isBusFull && (
              <SeatMap
                busLayout={busLayout}
                selectedSeats={selectedSeats}
                pendingSeats={pendingSeats || []}
                pendingReleaseSeats={pendingReleaseSeats || []}
                takenSeats={actualTaken}
                temporaryTakenSeats={actualTempTaken}
                blockedSeats={blockedSeats || []}
                basePrice={basePrice}
                pricingTiers={pricingTiers}
                onSeatSelect={onSeatSelect}
                maxSeats={maxSeats}
                maxSelectableRow={busLayout.maxSelectableRow}
                adminMode={false}
              />
            )}
            {!isBusFull && (
              <div>
                <SeatLegend
                  showPricingInfo={true}
                  basePrice={basePrice}
                  pricingTiers={pricingTiers}
                  showFCFS={busLayout.maxSelectableRow != null}
                  adminMode={true}
                />
                {maxSeats > 0 && (() => {
                  let seatsSubtotal = 0;
                  const rows = selectedSeats.map(function(seatId) {
                    const total = getSeatPrice(seatId, basePrice, busType, pricingTiers);
                    const addOn = total - basePrice;
                    seatsSubtotal += total;
                    return { seatId, base: basePrice, addOn, total };
                  });
                  const unassignedCount = Math.max(0, maxSeats - selectedSeats.length);
                  const unassignedTotal = unassignedCount * basePrice;
                  seatsSubtotal += unassignedTotal;
                  const grandTotal = showFees ? seatsSubtotal + RESERVATION_FEE + FUEL_SURCHARGE : seatsSubtotal;
                  return (
                    <div className="selected-seats-summary">
                      <div className="summary-title">{selectedSeats.length > 0 ? 'Selected Seats' : 'Seat Pricing'}</div>
                      <div className="selected-seats-list">
                        {rows.map(function(r) {
                          return (
                            <div key={r.seatId} className="selected-seat-item-breakdown">
                              <div className="seat-breakdown-header">
                                <span className="seat-id">{r.seatId}</span>
                                <span className="seat-price">{numeral(r.total).format('$0,0.00')}</span>
                              </div>
                              <div className="seat-breakdown-row">
                                <span>Base</span>
                                <span>{numeral(r.base).format('$0,0.00')}</span>
                              </div>
                              <div className="seat-breakdown-row">
                                <span>Add-on</span>
                                <span>+{numeral(r.addOn).format('$0,0.00')}</span>
                              </div>
                            </div>
                          );
                        })}
                        {unassignedCount > 0 && (
                          <div className="selected-seat-item-breakdown unassigned-breakdown">
                            <div className="seat-breakdown-header">
                              <span className="seat-id">{unassignedCount} Unassigned</span>
                              <span className="seat-price">{numeral(unassignedTotal).format('$0,0.00')}</span>
                            </div>
                            <div className="seat-breakdown-row">
                              <span>{unassignedCount} x {numeral(basePrice).format('$0,0.00')} base</span>
                              <span>{numeral(unassignedTotal).format('$0,0.00')}</span>
                            </div>
                          </div>
                        )}
                      </div>
                      {showFees && (
                        <div className="selected-seats-fees">
                          <div className="seat-breakdown-row">
                            <span>Reservation Fee</span>
                            <span>+{numeral(RESERVATION_FEE).format('$0,0.00')}</span>
                          </div>
                          <div className="seat-breakdown-row">
                            <span>Fuel Surcharge</span>
                            <span>+{numeral(FUEL_SURCHARGE).format('$0,0.00')}</span>
                          </div>
                        </div>
                      )}
                      <div className="selected-seats-total">
                        <span>{showFees ? 'Total' : 'Subtotal'}</span>
                        <span>{numeral(grandTotal).format('$0,0.00')}</span>
                      </div>
                    </div>
                  );
                })()}
              </div>
            )}
          </div>
        </div>
        {showCapacityWarning && (
          <div className="seat-capacity-warning">
            Only {availableCount} seat{availableCount !== 1 ? 's' : ''} available on the bus. {maxSeats - availableCount} seat(s) will be unassigned.
          </div>
        )}
      </div>
    );
  }

  renderDepartSeatSelection() {
    const search = queryStringToJSON(this.props.location.search);
    const basePrice = this.getDepartBasePrice();
    const isRoundTrip = !!search.return_slot;
    return this.renderSeatSection(
      'Select Departure Seats',
      this.getDepartBusType(),
      basePrice,
      this.state.selectedDepartSeats,
      this.handleDepartSeatSelect,
      this.state.departTakenSeats,
      this.state.departTempTakenSeats,
      (typeof this.state.departActiveReservations === 'number')
        ? this.state.departActiveReservations
        : (parseInt(search.depart_bus_total, 10) || 0),
      this.state.departPricingTiers,
      this.state.departBlockedSeats,
      this.state.departCapacity,
      this.state.pendingDepartSeats,
      this.state.conflictedDepartSeats,
      this.state.pendingReleaseDepartSeats,
      !isRoundTrip
    );
  }

  renderReturnSeatSelection() {
    const search = queryStringToJSON(this.props.location.search);
    const basePrice = this.getReturnBasePrice();
    return this.renderSeatSection(
      'Select Return Seats',
      this.getReturnBusType(),
      basePrice,
      this.state.selectedReturnSeats,
      this.handleReturnSeatSelect,
      this.state.returnTakenSeats,
      this.state.returnTempTakenSeats,
      (typeof this.state.returnActiveReservations === 'number')
        ? this.state.returnActiveReservations
        : (parseInt(search.return_bus_total, 10) || 0),
      this.state.returnPricingTiers,
      this.state.returnBlockedSeats,
      this.state.returnCapacity,
      this.state.pendingReturnSeats,
      this.state.conflictedReturnSeats,
      this.state.pendingReleaseReturnSeats,
      true
    );
  }

  renderCapacityWarning() {
    const search = queryStringToJSON(this.props.location.search);
    const seatCount = parseInt(this.state.seats, 10) || 0;
    if (seatCount === 0) {
      return null;
    }
    const remainingDepart = parseInt(search.remainingSeats, 10);
    const remainingReturn = search.return_slot ? parseInt(search.remainingSeatsReturn, 10) : null;
    const departExceeds = !isNaN(remainingDepart) && seatCount > remainingDepart;
    const returnExceeds = remainingReturn !== null && !isNaN(remainingReturn) && seatCount > remainingReturn;

    if (!departExceeds && !returnExceeds) {
      return null;
    }

    return (
      <Row>
        <Col md={12}>
          <div className="capacity-exceeded-warning">
            <strong>Capacity Warning:</strong>
            {departExceeds && (
              <div>Departure bus has {remainingDepart} seat{remainingDepart !== 1 ? 's' : ''} remaining. You are booking {seatCount} seat{seatCount !== 1 ? 's' : ''} which exceeds available capacity.</div>
            )}
            {returnExceeds && (
              <div>Return bus has {remainingReturn} seat{remainingReturn !== 1 ? 's' : ''} remaining. You are booking {seatCount} seat{seatCount !== 1 ? 's' : ''} which exceeds available capacity.</div>
            )}
            <div>You can proceed anyway -- extra seats will be unassigned.</div>
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    const { submitted } = this.state;
    return (
      <div className="content">
        <Grid fluid>
          {this.state.result && this.state.result.departTrip && <Row>
            <Col md={12}>
              <div className="res-confirmed">
                <div>
                  <div>OUTBOUND RESERVATION #: {config.formatReservationNumber(this.state.result.departTrip.code)}</div>
                  <div>(Name: {this.state.result.departTrip.name} DOT: {moment(this.state.result.departTrip.date, 'YYYY-MM-DD').format('dddd MMMM DD YYYY')} From: {this.state.result.departTrip.address} At: {moment(this.state.result.departTrip.time, 'HH:mm:ss').format('hh:mm A')} Seats: {this.state.result.departTrip.seats})</div>
                </div>
                {this.state.result.returnTrip && <div>
                  <div>RETURN RESERVATION #: {config.formatReservationNumber(this.state.result.returnTrip.code)}</div>
                  <div>(Return DOT: {moment(this.state.result.returnTrip.date, 'YYYY-MM-DD').format('dddd MMMM DD YYYY')} From: {this.state.result.returnTrip.address} At: {moment(this.state.result.returnTrip.time, 'HH:mm:ss').format('hh:mm A')})</div>
                </div>}
                <div>Customer was just emailed the reservation information (to email address: {this.state.result.departTrip.email})</div>
              </div>
            </Col>
          </Row>}
          {this.state.pastDate && <Row>
            <Col md={12}>
              <div className="past-date">The date for this reservation is in the past</div>
            </Col>
          </Row>}
          {this.renderCapacityWarning()}
          <Row>
            <Col md={12}>
              <Card
                title="Add Reservation"
                content={
                  <form name="profileForm" onSubmit={this.handleSubmit}>
                    {queryStringToJSON(this.props.location.search).return_slot && <div className="return-info">Bus From {queryStringToJSON(this.props.location.search).depart_address} on {moment(queryStringToJSON(this.props.location.search).slot, 'HH:mm:ss').format('hh:mm a')} and Returning From {queryStringToJSON(this.props.location.search).return_address} on {moment(queryStringToJSON(this.props.location.search).return_slot, 'HH:mm:ss').format('hh:mm a')}</div>}
                    <div className="return-info price-breakdown">Price Breakdown: From {queryStringToJSON(this.props.location.search).departCity} - To {queryStringToJSON(this.props.location.search).arriveCity}: {numeral(this.getDepartBasePrice()).format('$0.00')} base per seat{this.state.selectedDepartSeats.length > 0 ? ' (' + this.state.selectedDepartSeats.length + ' selected)' : ''}. {queryStringToJSON(this.props.location.search).return_slot && ('Return From ' + queryStringToJSON(this.props.location.search).returnDepartCity + ' To ' + queryStringToJSON(this.props.location.search).returnArriveCity +': ' + numeral(this.getReturnBasePrice()).format('$0.00') + ' base per seat' + (this.state.selectedReturnSeats.length > 0 ? ' (' + this.state.selectedReturnSeats.length + ' selected)' : '') + '.')} (Also included in total {numeral(RESERVATION_FEE).format('0.00')} Reservation fee & {numeral(FUEL_SURCHARGE).format('0.00')} Fuel Surcharge). Total : {numeral(this.getTotal()).format('$0.00')}<div className="stop-seats">{this.getDates() +' , ' + this.getStopSeats()}</div></div>
                    <FormInputs
                      ncols={["col-md-4", "col-md-4", "col-md-4"]}
                      proprieties={[
                        {
                          label: "Email",
                          type: "email",
                          bsClass: "form-control",
                          placeholder: "Email",
                          value: this.state.email,
                          name: 'email',
                          onChange: this.handleChange,
                          onBlur: this.getCustomerDetails
                        },
                        {
                          label: "First Name",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "First Name",
                          value: this.state.firstName,
                          name: 'firstName',
                          onChange: this.handleChange
                        },
                        {
                          label: "Last Name",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Last Name",
                          value: this.state.lastName,
                          name: 'lastName',
                          onChange: this.handleChange
                        }
                      ]}
                    />
                    <Row className="error-row">
                      <Col md={4}>{submitted && !this.state.email && <div className="error">Email is required</div>}</Col>
                      <Col md={4}>{submitted && !this.state.firstName && <div className="error">First name is required</div>}</Col>
                      <Col md={4}>{submitted && !this.state.lastName && <div className="error">Last name is required</div>}</Col>
                    </Row>
                    <FormInputs
                      ncols={["col-md-6", "col-md-6"]}
                      proprieties={[
                        {
                          label: "Phone",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Phone",
                          value: this.state.phone,
                          name: 'phone',
                          onChange: this.handleChange
                        },
                        {
                          label: "Zip",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "zip",
                          value: this.state.zip,
                          name: 'zip',
                          onChange: this.handleChange
                        }
                      ]}
                    />
                    <Row className="error-row">
                      <Col md={6}>{submitted && !this.state.phone && <div className="error">Phone is required</div>}</Col>
                      <Col md={6}>{submitted && !this.state.zip && this.state.paymentMethod !== 'Ivy' && <div className="error">Zip is required</div>}</Col>
                    </Row>
                    <FormInputs
                      ncols={["col-md-4", "col-md-4", "col-md-4"]}
                      proprieties={[
                        {
                          label: "Seats",
                          type: "text",
                          componentClass: "select",
                          bsClass: "form-control",
                          placeholder: "Seats",
                          value: this.state.seats,
                          name: 'seats',
                          options: this.state.seatOptions,
                          onChange: this.handleChange
                        },
                        {
                          label: "Payment Method",
                          type: "text",
                          componentClass: "select",
                          bsClass: "form-control",
                          placeholder: "Payment Method",
                          value: this.state.paymentMethod,
                          name: 'paymentMethod',
                          options: this.state.methods,
                          onChange: this.handleChange
                        },
                        {
                          label: (this.state.paymentMethod === 'Ivy' ? 'Price Per Seat Paid Through Ivy Media' : 'Custom Price Per Seat'),
                          type: "number",
                          bsClass: "form-control",
                          placeholder: "price",
                          value: this.state.price,
                          name: 'price',
                          onChange: this.handleChange
                        }
                      ]}
                    />
                    <Row className="error-row">
                      <Col md={4}>{submitted && !this.state.seats && <div className="error">Seats is required</div>}</Col>
                      <Col md={4}>{submitted && !this.state.paymentMethod && <div className="error">Method is required</div>}</Col>
                      <Col md={4}>{submitted && this.state.paymentMethod === 'Ivy' && !this.state.price && <div className="error">Price per seat is required</div>}</Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <div style={{fontSize: '12px', color: this.state.price ? '#e65100' : '#666', margin: '0 0 10px', lineHeight: '1.5'}}>
                          {this.state.price
                            ? 'Custom price in use: every ticket on this reservation is priced at $' + this.state.price + ' instead of the standard fare. Seat add-ons are charged on top, and fees still apply.'
                            : 'Custom Price Per Seat overrides the standard fare for every ticket on this reservation. Seat add-ons are charged on top of it. Leave blank to use the normal fare.'}
                        </div>
                      </Col>
                    </Row>
                    {this.renderDepartSeatSelection()}
                    {queryStringToJSON(this.props.location.search).return_slot && this.renderReturnSeatSelection()}
                    <FormInputs
                      ncols={["col-md-12"]}
                      proprieties={[
                        {
                          label: "Remark",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Remark",
                          value: this.state.remark,
                          name: 'remark',
                          onChange: this.handleChange
                        }
                      ]}
                    />
                    {(() => {
                      const search = queryStringToJSON(this.props.location.search);
                      const seatCount = parseInt(this.state.seats, 10) || 0;
                      const hasDepartSeats = this.state.selectedDepartSeats.length > 0;
                      const hasReturnSeats = this.state.selectedReturnSeats.length > 0;
                      const isRoundTrip = !!search.return_slot;
                      const departBasePrice = this.getDepartBasePrice();
                      const returnBasePrice = isRoundTrip ? (this.getReturnBasePrice()) : 0;

                      if (seatCount === 0 && !hasDepartSeats && !hasReturnSeats) {
                        return null;
                      }

                      const departRows = hasDepartSeats
                        ? this.state.selectedDepartSeats.map((seatId) => {
                            const total = this.getSeatPriceForId(seatId, this.getDepartBusType());
                            return { seatId, base: departBasePrice, addOn: total - departBasePrice, total };
                          })
                        : [];
                      const departUnassigned = Math.max(0, seatCount - this.state.selectedDepartSeats.length);
                      const departAssignedTotal = departRows.reduce((sum, r) => sum + r.total, 0);
                      const departSubtotal = departAssignedTotal + (departUnassigned * departBasePrice);

                      const returnRows = hasReturnSeats
                        ? this.state.selectedReturnSeats.map((seatId) => {
                            const total = getSeatPrice(seatId, returnBasePrice, this.getReturnBusType(), this.state.returnPricingTiers);
                            return { seatId, base: returnBasePrice, addOn: total - returnBasePrice, total };
                          })
                        : [];
                      const returnUnassigned = isRoundTrip ? Math.max(0, seatCount - this.state.selectedReturnSeats.length) : 0;
                      const returnAssignedTotal = returnRows.reduce((sum, r) => sum + r.total, 0);
                      const returnSubtotal = isRoundTrip
                        ? returnAssignedTotal + (returnUnassigned * returnBasePrice)
                        : 0;

                      const grandTotal = departSubtotal + returnSubtotal + RESERVATION_FEE + FUEL_SURCHARGE;

                      return (
                        <div className="selected-seats-overview">
                          <div className="seats-overview-section">
                            <div className="overview-section-title">Departure</div>
                            <div className="seats-overview-row">
                              <strong>Pickup: </strong>
                              <span>{search.depart_address}</span>
                            </div>
                            <div className="seats-overview-row">
                              <strong>Dropoff: </strong>
                              <span>{search.arrive_address || search.arriveCity}</span>
                            </div>
                            <div className="seats-overview-row">
                              <strong>Bus Type: </strong>
                              <span>{this.getDepartBusType()}</span>
                            </div>
                            <div className="seats-overview-row">
                              <strong>Date: </strong>
                              <span>{moment(search.date, 'YYYY-MM-DD').format('ddd, MMM DD YYYY')}</span>
                            </div>
                            <div className="seats-overview-row">
                              <strong>Time: </strong>
                              <span>{moment(search.slot, 'HH:mm:ss').format('hh:mm A')}</span>
                            </div>
                            <div className="overview-pricing-block">
                              <div className="seats-overview-row">
                                <strong>Seats: </strong>
                                <span>
                                  {hasDepartSeats ? this.state.selectedDepartSeats.join(', ') : ''}
                                  {hasDepartSeats && departUnassigned > 0 ? ', ' : ''}
                                  {departUnassigned > 0 && (departUnassigned + ' unassigned')}
                                  {!hasDepartSeats && seatCount === 0 && 'None selected'}
                                  {!hasDepartSeats && seatCount > 0 && departUnassigned === 0 && seatCount + ' (no seat selection)'}
                                </span>
                              </div>
                              {departRows.map((r) => (
                                <div key={r.seatId} className="overview-seat-line">
                                  <span className="overview-seat-id">{r.seatId}</span>
                                  <span className="overview-seat-detail">
                                    {numeral(r.base).format('$0,0.00')}
                                    {r.addOn > 0 && <span className="overview-addon"> + {numeral(r.addOn).format('$0,0.00')} addon</span>}
                                    <span className="overview-seat-total"> = {numeral(r.total).format('$0,0.00')}</span>
                                  </span>
                                </div>
                              ))}
                              {departUnassigned > 0 && (
                                <div className="overview-seat-line unassigned">
                                  <span className="overview-seat-id">{departUnassigned} unassigned</span>
                                  <span className="overview-seat-detail">
                                    {departUnassigned} x {numeral(departBasePrice).format('$0,0.00')}
                                    <span className="overview-seat-total"> = {numeral(departUnassigned * departBasePrice).format('$0,0.00')}</span>
                                  </span>
                                </div>
                              )}
                              {seatCount > 0 && (
                                <div className="overview-subtotal-line">
                                  <strong>Departure Subtotal</strong>
                                  <span>{numeral(departSubtotal).format('$0,0.00')}</span>
                                </div>
                              )}
                            </div>
                          </div>

                          {isRoundTrip && (
                            <div className="seats-overview-section">
                              <div className="overview-section-title">Return</div>
                              <div className="seats-overview-row">
                                <strong>Pickup: </strong>
                                <span>{search.return_address}</span>
                              </div>
                              <div className="seats-overview-row">
                                <strong>Dropoff: </strong>
                                <span>{search.return_arrive_address || search.returnArriveCity}</span>
                              </div>
                              <div className="seats-overview-row">
                                <strong>Bus Type: </strong>
                                <span>{this.getReturnBusType()}</span>
                              </div>
                              <div className="seats-overview-row">
                                <strong>Date: </strong>
                                <span>{moment(search.return_date, 'YYYY-MM-DD').format('ddd, MMM DD YYYY')}</span>
                              </div>
                              <div className="seats-overview-row">
                                <strong>Time: </strong>
                                <span>{moment(search.return_slot, 'HH:mm:ss').format('hh:mm A')}</span>
                              </div>
                              <div className="overview-pricing-block">
                                <div className="seats-overview-row">
                                  <strong>Seats: </strong>
                                  <span>
                                    {hasReturnSeats ? this.state.selectedReturnSeats.join(', ') : ''}
                                    {hasReturnSeats && returnUnassigned > 0 ? ', ' : ''}
                                    {returnUnassigned > 0 && (returnUnassigned + ' unassigned')}
                                    {!hasReturnSeats && seatCount === 0 && 'None selected'}
                                    {!hasReturnSeats && seatCount > 0 && returnUnassigned === 0 && seatCount + ' (no seat selection)'}
                                  </span>
                                </div>
                                {returnRows.map((r) => (
                                  <div key={r.seatId} className="overview-seat-line">
                                    <span className="overview-seat-id">{r.seatId}</span>
                                    <span className="overview-seat-detail">
                                      {numeral(r.base).format('$0,0.00')}
                                      {r.addOn > 0 && <span className="overview-addon"> + {numeral(r.addOn).format('$0,0.00')} addon</span>}
                                      <span className="overview-seat-total"> = {numeral(r.total).format('$0,0.00')}</span>
                                    </span>
                                  </div>
                                ))}
                                {returnUnassigned > 0 && (
                                  <div className="overview-seat-line unassigned">
                                    <span className="overview-seat-id">{returnUnassigned} unassigned</span>
                                    <span className="overview-seat-detail">
                                      {returnUnassigned} x {numeral(returnBasePrice).format('$0,0.00')}
                                      <span className="overview-seat-total"> = {numeral(returnUnassigned * returnBasePrice).format('$0,0.00')}</span>
                                    </span>
                                  </div>
                                )}
                                {seatCount > 0 && (
                                  <div className="overview-subtotal-line">
                                    <strong>Return Subtotal</strong>
                                    <span>{numeral(returnSubtotal).format('$0,0.00')}</span>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          <div className="seats-overview-section overview-totals-section">
                            <div className="overview-fee-line">
                              <span>Reservation Fee</span>
                              <span>{numeral(RESERVATION_FEE).format('$0,0.00')}</span>
                            </div>
                            <div className="overview-fee-line">
                              <span>Fuel Surcharge</span>
                              <span>{numeral(FUEL_SURCHARGE).format('$0,0.00')}</span>
                            </div>
                            <div className="overview-grand-total">
                              <strong>Grand Total</strong>
                              <span>{numeral(grandTotal).format('$0,0.00')}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })()}
                    {this.state.paymentMethod === 'card' && this.state.credits > 0 &&
                      <div className="row clearfix">
                        <Col md={12}>
                          <div className="apply-credit-row">Available credits in user account: {numeral(this.state.credits).format('$0.00')}
                            {!this.state.useCredits ? <Button bsStyle="info" fill onClick={this.applyCredit.bind(this)}>Apply</Button> : ''}
                            {this.state.useCredits ? <Button bsStyle="danger" fill onClick={this.removeCredit.bind(this)}>Subtract</Button> : ''}
                          </div>
                        </Col>
                      </div>
                    }
                    {this.state.paymentMethod === 'card' && this.state.points > 0 &&
                      <div className="row clearfix">
                        <Col md={12}>
                          <div className="apply-credit-row">Available points in user account: {this.state.points}
                            {!this.state.usePoints ? <Button disabled={this.checkDisabledPoints()} bsStyle="info" fill onClick={this.applyPoints.bind(this)}>Apply</Button> : ''}
                            {this.state.usePoints ? <Button bsStyle="danger" fill onClick={this.removePoints.bind(this)}>Remove</Button> : ''}
                          </div>
                        </Col>
                      </div>
                    }
                    {this.state.useCredits && this.state.totalCredits > 0 ?
                      <div className="row clearfix">
                        <Col md={12}>
                          <div className="apply-credit-row">
                            Applied ${this.state.totalCredits} Worth of Credit
                          </div>
                        </Col>
                      </div> : ''
                    }
                    {(this.state.paymentMethod === 'card' && (this.state.payment > 0 || this.state.usePoints || this.state.useCredits)) ?
                      <div className="row clearfix">
                        <Col md={12}>
                          <div className="apply-credit-row">
                            Total Payment to be made : {numeral(this.state.useCredits || this.state.usePoints ? this.state.payment : this.getTotal()).format('$0.00')}
                          </div>
                        </Col>
                      </div> : ''
                    }
                    {this.state.paymentMethod === 'card' && ((!this.state.usePoints && !this.state.useCredits) || (this.state.payment > 0)) &&
                      <div>
                        <div className="row clearfix">
                          <div className="col-sm-6 form-group">
                            <label className="formLable">NAME ON CARD (If different from above)</label>
                            <input ref="cardHolder" name="cardHolder" required={this.state.payment > 0} value={this.state.cardHolder} onChange={this.handleChange.bind(this)} type="text" className="form-control" placeholder="Name On Card" />
                            {submitted && !this.state.cardHolder && <div className="error">Name is required</div>}
                          </div>
                          <div className="col-sm-6 form-group">
                            <label className="formLable">CREDIT CARD NUMBER</label>
                            <InputMask maskChar='' mask="9999-9999-9999-9999" ref="number" onChange={this.handleChange.bind(this)} value={this.state.number} name="number" required={this.state.payment > 0} className='form-control' placeholder="Credit Card Number" />
                            {submitted && !this.state.number && <div className="error">Number is required</div>}
                          </div>
                        </div>
                        <div className="row clearfix">
                          <div className="col-sm-4 form-group">
                            <label className="formLable">EXMONTH</label>
                            <select ref="month" required={this.state.payment > 0} name="month" value={this.state.month} onChange={this.handleChange.bind(this)} className='form-control'>
                              <option value=''>MM</option>
                              {this.state.months.map((item, index) => {
                                return (
                                  <option key={index}>{item}</option>
                                )
                              })}
                            </select>
                            {submitted && !this.state.month && <div className="error">Month is required</div>}
                          </div>
                          <div className="col-sm-4 form-group">
                            <label className="formLable">EXYEAR</label>
                            <select ref="year" name="year" value={this.state.year} onChange={this.handleChange.bind(this)} required={this.state.payment > 0} className='form-control'>
                              <option value=''>YY</option>
                              {this.state.years.map((item, index) => {
                                return (
                                  <option key={index}>{item}</option>
                                )
                              })}
                            </select>
                            {submitted && !this.state.year && <div className="error">Year is required</div>}
                          </div>
                          <div className="col-sm-4 form-group">
                            <label className="formLable">SEC CODE</label>
                            <InputMask maskChar='' mask="9999" ref="cvv"required={this.state.payment > 0} onChange={this.handleChange.bind(this)} value={this.state.cvv} name="cvv" className='form-control' placeholder="SEC" />
                            {submitted && !this.state.cvv && <div className="error">Cvv is required</div>}
                          </div>
                        </div>
                      </div>
                    }
                    <Button bsStyle="info" disabled={this.state.loading} fill type="submit">
                      Add Reservation
                    </Button>
                    {this.state.loading && submitted && 
                      <img alt="" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    }
                    {this.state.error && <div className="error">{this.state.error}</div>}
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
 
const mapStateToProps = state => {
  return {
    stops: state.stops.items
  };
}

export default connect(mapStateToProps)(AddMainReservation);
